module.exports = __webpack_public_path__ + "static/img/biankuang.837a1caf.png";